import * as React from "react";
import "./Courses.sass"
import IconItemGrid, {IconItemGridType} from "../../../../_components/common/grid/IconItemGrid";
import {useDispatch, useSelector} from "react-redux";
import {useEffect} from "react";
import {getCourses, setEmpty} from "../../../../_actions/commonService";
import SimpleGrid from "../../../../_containers/grid/SimpleGrid";
import {courseList} from "./courseList";

export default function Courses() {

    const {data, status} = useSelector(state => state.common.courses)
    const dispatch = useDispatch();

    useEffect(() => {
        if (status === 'idle') {
            dispatch(getCourses())
        }
    }, [status, dispatch]);

    useEffect(() => {
        document.title = 'КьюАй - Курсы';
        return () => {
            dispatch(setEmpty())
        }
    }, [])

    return (
        <div className="courses-wrapper">
            <div className="courses-context">
                <SimpleGrid>
                    {
                        courseList.map((item, i) => <IconItemGrid key={`item-${item.name}`}
                                                      link={`${item.id}`}
                                                      svg={data && data[i].avatar}
                                                      title={item.name}
                                                      backgroundColor={item.color}
                                                      type={IconItemGridType.COMMON}/>)
                        }
                </SimpleGrid>
            </div>
        </div>
    )
}